import { useQuery } from '@tanstack/react-query';

import type { PersonalBoard } from '@tasks/contracts';

import { getPersonalBoard, type PersonalBoardParams } from '../../api/personalBoard';
import { queryKeys } from '../../api/queryKeys';
import { serializeParams } from '../../hooks/useUrlState';

export type PersonalBoardView = {
  readonly board: PersonalBoard | null;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly error: unknown;
  refetch: () => void;
};

/** Данные персональной доски; поиск и лимит колонок приходят из URL/состояния. */
export function usePersonalBoard(params: PersonalBoardParams): PersonalBoardView {
  const serialized = serializeParams(params as Record<string, string | number | undefined>);
  const query = useQuery({
    queryKey: queryKeys.personalBoard.view(serialized),
    queryFn: ({ signal }) => getPersonalBoard(params, signal),
    // Доска не подключена к комнате проекта: поддерживаем её свежей опросом.
    refetchInterval: 60_000,
    staleTime: 15_000,
  });

  return {
    board: query.data ?? null,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: () => {
      void query.refetch();
    },
  };
}
